module.exports = __webpack_public_path__ + "static/media/7.8d87712a.jpg";